'use strict';

angular.module('ecrd.states')
    .component('formStates', {
        templateUrl: 'modules/states/components/form-states/template.html',
        controller: 'FormStatesController',
        bindings: {
            formId: '@',
            listIndices: '<', // índices del formulario
        },
    });
